import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "./slices/authenticationSlice";
import conferenceApplicationsReducer from "./slices/conferenceApplicationsSlice";
import specialSessionsReducer from "./slices/specialSessionsSlice";

export const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    conferenceApplications: conferenceApplicationsReducer,
    specialSessions: specialSessionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;